import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionRevealSection } from './components/SolutionRevealSection';
import { Mapa5RSection } from './components/Mapa5RSection';
import { OfferSection } from './components/OfferSection';
import { DifferentiationSection } from './components/DifferentiationSection';
import { AudienceSection } from './components/AudienceSection';
import { FinalCTASection } from './components/FinalCTASection';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen w-full bg-white font-sans text-[#1A1A1A]" data-id="element-0">
      <main className="flex flex-col w-full" data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionRevealSection data-id="element-5" />
        <Mapa5RSection data-id="element-6" />
        <OfferSection data-id="element-7" />
        <DifferentiationSection data-id="element-8" />
        <AudienceSection data-id="element-9" />
        <FinalCTASection data-id="element-10" />
      </main>

      {/* Simple Footer */}
      <footer className="bg-[#111] text-gray-500 py-8 text-center text-sm" data-id="element-11">
        <p data-id="element-12">
          © {new Date().getFullYear()} Link Academy. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-13">
          Este sitio no es parte de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}